import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { saveAs } from 'file-saver';
import { ImportJobsDTO } from '../../../../../core/models/job';
import { JobsService } from '../../../../../core/services/jobs.service';

@Component({
  selector: 'app-import-jobs',
  templateUrl: './import-jobs.component.html',
  styleUrls: ['./import-jobs.component.scss']
})
export class ImportJobsComponent implements OnInit {

  fileName: string;
  importArray: ImportJobsDTO[] = [];
  @ViewChild('fileUpload') fileUpload;

  constructor(
    public dialog: MatDialogRef<ImportJobsComponent>,
    private snackBar: MatSnackBar,
    private jobService: JobsService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      importType: string,
      requiredParams: string,
      uniqueFields: string,
      depName: string
    },
  ) { }

  ngOnInit(): void { }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.importArray.length > 0) {
      this.jobService.importJobs(this.importArray, this.data.depName).subscribe({
        next: (data: any) => {
          this.snackBar.open(data.actionMessage, 'Ok', {
            duration: 5000
          })
        }, error: (err) => {
          this.snackBar.open(err.error.actionMessage, "Ok", {
            duration: 5000
          })
        }
      })
      this.snackBar.open("Import jobs is in progress", "Ok", {
        duration: 5000
      })
      this.dialog.close(true);
    }
  }

  onFileSelected(event) {
    const file: File = event.target.files[0];
    if (file) {
      try {

        const fileExtension = file?.name?.split('.').pop().toLowerCase();
        if (fileExtension == 'xlsx') {
          this.snackBar.open("Please upload only MS-DOS or Comma Delimited .csv file.", "Ok", {
            duration: 5000
          })
          return;
        }

        this.importArray.length = 0;
        this.fileName = file.name;
        let reader: FileReader = new FileReader();
        reader.readAsText(file);
        reader.onload = (e) => {
          let csv: string = reader.result as string;
          csv = csv.trim()
          let csvToRowArray = csv.split("\r\n").filter(e => !e.includes(",,,,,,,,,,,,"));
          let headers = csvToRowArray[0].split(",").map(a => a?.split(" (")[0].trim());
          let props = Object.getOwnPropertyNames(new ImportJobsDTO());
          for (let index = 1; index < csvToRowArray.length; index++) {
            let row = csvToRowArray[index].split(",");
            let user = Object.create(ImportJobsDTO)
            props.forEach((prop, i) => {
              Object.assign(user, { [prop]: row[this.getIndexOfString(prop.toLowerCase(), headers)] })
            });
            this.importArray.push(user)
          }
          if (this.importArray.length == 0) {
            this.snackBar.open("Unable to read file data. Because uploaded file is of wrong type or contains no data.", "Ok", {
              duration: 5000
            })
            return;
          }
        }
      } catch (error) {
        this.importArray = [];
        this.snackBar.open("Error reading contents of file.", "Ok", {
          duration: 5000
        })
      }
    }
  }

  getIndexOfString(value, array: string[]) {
    return array.findIndex(a => a.toLowerCase() == value)
  }

  onFileChange() {
    this.fileUpload.nativeElement.value = "";
  }

  downloadTemplate() {
    let headers = Object.keys(new ImportJobsDTO());;
    //let headers = this.data.requiredParams.split(",");
    const header = headers;
    //let csv = ["workstation1,10.0.0.10,,,,5"];
    let csv = [];
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, `ImportJobs.csv`);
  }

}
